module.exports = __webpack_public_path__ + "assets/burst.c895e119.svg";